import type { LabeledEnumDto, TimeslotDto } from "@/lib/client";
import { Store } from "@tanstack/store";

type EnumStoreState = {
	subjects: LabeledEnumDto[];
	levels: LabeledEnumDto[];
	schools: LabeledEnumDto[];
	timeSlots: TimeslotDto[];
};

export const enumStore = new Store<EnumStoreState>({
	subjects: [],
	levels: [],
	schools: [],
	timeSlots: [],
});

export function setSubjects(subjects: LabeledEnumDto[]) {
	enumStore.setState((state) => ({ ...state, subjects }));
}

export function setLevels(levels: LabeledEnumDto[]) {
	enumStore.setState((state) => ({ ...state, levels }));
}

export function setSchools(schools: LabeledEnumDto[]) {
	enumStore.setState((state) => ({ ...state, schools }));
}

export function setTimeSlots(timeSlots: TimeslotDto[]) {
	enumStore.setState((state) => ({ ...state, timeSlots }));
}

export function getSubjectLabel(value: string | undefined): string {
	if (!value) return "-";
	const item = enumStore.state.subjects.find((s) => s.value === value);
	return item?.label || value;
}

export function getLevelLabel(value: string | undefined): string {
	if (!value) return "-";
	const item = enumStore.state.levels.find((l) => l.value === value);
	return item?.label || value;
}

export function getSchoolLabel(value: string | undefined): string {
	if (!value) return "-";
	const item = enumStore.state.schools.find((s) => s.value === value);
	return item?.label || value;
}

export function getTimeSlotLabel(value: string | undefined): string {
	if (!value) return "-";
	const item = enumStore.state.timeSlots.find((t) => t.value === value);
	return item?.label || value;
}

export function getTimeSlot(value: string | undefined): TimeslotDto | null {
	if (!value) return null;
	const item = enumStore.state.timeSlots.find((t) => t.value === value);
	return item || null;
}
